<div class="sidebar" #left_part_holder [ngClass]="{ 'sidebar--collapsed': isSidebarToggled }">
  <div class="d-flex align-items-center logo-bar">
    <app-logo></app-logo>

    <button (click)="toggleMenu()" class="togglebtn">
      <i class="fal fa-angle-left"></i>
    </button>
  </div>

  <div class="menu-bar">
    <div class="nav-bar">
      <mat-accordion [displayMode]="'flat'" [multi]="false">
        <div *ngFor="let navRoute of navRoutes">
         <mat-expansion-panel hideToggle *ngIf="navRoute.hasAccess" [expanded]="!isSidebarToggled && navRoute.isActive" (opened)="openSidebar(navRoute)"
          class="nav-bar_item nav-bar_item--group-link"  #panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="nav-bar_link" [ngClass]="{
                  active_tab:
                    navRoute.url.includes('/dashboard') &&
                    navRoute.isActive == true
                }" (click)="redirectTodashboard(navRoute.url)">
                <span class="nav-bar_icon" [style.backgroundImage]="'url(/' + navRoute.iconUrl + ')'"></span>
                <span class="nav-bar_link-text" [ngClass]="{ 'nav-bar_link-text--hidden': isSidebarToggled }">{{
                  navRoute.name }}</span>
                <div class="nav-bar_beta" *ngIf="navRoute.isBeta">
                  Beta
                </div>
                <div class="nav-bar_freemium" *ngIf="navRoute.freemium && userInfo.isShipyard === 1"
                  (click)="openFreemiumDialog($event)" [ngClass]="{
                    'nav-bar_freemium--red': !userInfo.freemiumAvail
                  }"></div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li
              class="nav-bar_item"
              *ngFor="let childRoute of navRoute.children; let i = index;"
            >
            <mat-accordion [displayMode]="'flat'" [multi]="true" *ngIf="childRoute.hasAccess">
              <mat-expansion-panel hideToggle  #subMenuPanel>
                <mat-expansion-panel-header>
                  <div class="nav-child">
                    <a class="nav-bar_link nav-bar_link--child-link arrow-content" routerLinkActive="active"
                      [ngClass]="{'collapse' : childRoute?.children?.length && childRoute.openChildIndex !== i,'expend' : childRoute.openChildIndex === i,
                      'inactive' : childRoute?.children?.length && childRoute.openChildIndex !== i,
                        'arrow-content':childRoute?.children?.length,'pe_none':childRoute.isComing}"
                      [routerLink]="childRoute?.children?.length? [] : childRoute.url"
                      (click)="closeOtherPanels(panel, navRoute,subMenuPanel,childRoute,i);"
                      >{{ childRoute.name }}
                     <span *ngIf="childRoute.name === 'Replenish'" class="nav-bar_counter ms-auto">({{queueCount}})</span> 
                     <span *ngIf="childRoute.name === 'Forecasting' || childRoute.name === 'Forecasting by sku' " class="nav-bar_counter ms-auto">({{purchasingQueueCount}})</span>
                      <div class="nav-bar_beta" *ngIf="childRoute.isBeta">
                        Beta
                      </div>
                      <div class="nav-bar_badge" *ngIf="childRoute.isComing">
                        Coming Soon
                      </div>
                    </a>
                  </div>
                </mat-expansion-panel-header>
                <div  *ngIf="childRoute?.children?.length">
                  <div >
                      <ul class="nav-bar_grandChild">
                        <li class="nav-bar_item" *ngFor="let grandchildRoute of childRoute?.children">
                          <a class="nav-bar_link nav-bar_link--child-link" routerLinkActive="active"  *ngIf="grandchildRoute.hasAccess"
                            [routerLink]="grandchildRoute.url"
                            (click)="closeOtherPanels(panel,navRoute,subMenuPanel,grandchildRoute)">{{
                            grandchildRoute.name }}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </li>
          </ul>
        </mat-expansion-panel>
        </div>

      </mat-accordion>
    </div>

    <!-- Loading data Message  -->
    <!--<div class="loadingData-msg" *ngIf="showLoginError && !isSidebarToggled">
      <p>We are still in the middle of loading your information.</p>
      <p>Thanks for your patience.</p>
      <div class="loader">
        <img src="assets/images/nineyard-loading.gif" class="loader-img" />
      </div>
    </div>-->

    <div class="bottom">
      <div class="invite" [ngClass]="{ 'inviteCollapsed': isSidebarToggled }" (click)="Invite()">
        <span>Invite & earn</span>
        <span class="icon">$</span>
      </div>
      <div class="feedback" (click)="feedback()">
        <i class="fal fa-comment"></i>
        <span>Feedback</span>
      </div>

      <div class="profile">
        <div class="profile_name" [matTooltip]="userInfo?.username">
          {{ userInfo?.username }}
        </div>
        <a class="profile_icon" [matMenuTriggerFor]="profilehover" #profilehoverTrigger="matMenuTrigger"
          (click)="buttonEnter(profilehoverTrigger)">
          <i class="fal fa-user-circle"></i></a>
      </div>
    </div>
  </div>
</div>

<mat-menu #profilehover="matMenu" class="profliehover-menu" direction="right" yPosition="above">
  <div>
    <h5 class="name">
      {{ userInfo?.username }} <span *ngIf="userInfo?.role == 'Admin'">{{ userInfo?.role }}</span>
    </h5>
    <h5 *ngIf="userInfo?.role != 'Admin'" class="email">
      {{ userInfo?.email }}
    </h5>
    <div class="link">
      {{ userInfo?.company }} <span >Company ID: {{ userInfo?.tenantId }}</span>
    </div>
    <div class="link">
      <a href="" (click)="logout()">Logout</a>
    </div>
  </div>
</mat-menu>
